export default {
  app: state => state.app,
}
